export default __webpack_public_path__ + "6a86304eabe23e3ab4121ce23884d528.png";